import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { Ticket_Interface } from 'src/app/Interface/Ticket_Interface';
import { Ticket_Ref_Interface } from 'src/app/Interface/Ticket_Ref_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TicketService {

constructor(private http:HttpClient) { }

  GetRecord(Token:String,readed:number):Observable<Array<Ticket_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Ticket?token="+Token+"&readed="+readed).pipe(
      map(data=>{
        return data as Array<Ticket_Interface>
      })
    )
  }

  GetDetail(Token:String,id:number):Observable<any>{
    return this.http.get(environment.BaseUrl + "Daro/Ticket/GetDetail?token="+Token+"&id="+id).pipe(
      map(data=>{
        return data as any
      })
    )
  }



  SubmitTicket(message: string ,cutomerId:number , title:string, category_id:number ,Token:String,file:Array<string>):Observable<any>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var model = {
      id:0,
      title:title,
      customer_id:cutomerId,
      category_id:category_id
    }

    var body={
      model:model,
      message:message,
      token:Token,
      files:file
    }


      return this.http.post(environment.BaseUrl + "Daro/Ticket/SubmitTicket",body,{headers}).pipe(
        map(data=>{
          return data as any
        })
      )

  }

  SubmitTicketAdmin(message: string ,customer:Array<Customer_List_Interface>, title:string  , category_id:number ,Token:String,file:Array<string>):Observable<any>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var local_customer:Array<number>=[]

    for(let item of customer)
    {
      local_customer.push(item.id)
    }

    var model = {
      id:0,
      title:title,

    }

    var body={
      model:model,
      message:message,
      token:Token,
      customer:local_customer,
      files:file,
      category_id:category_id,
    }


      return this.http.post(environment.BaseUrl + "Daro/Ticket/SubmitTicketAdmin",body,{headers}).pipe(
        map(data=>{
          return data as any
        })
      )

  }

  ReplyTicket(message: string ,id:number ,Token:String,file:Array<string>):Observable<any>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var model = {
      id:id,

    }

    var body={
      model:model,
      message:message,
      token:Token,
      files:file
    }


      return this.http.post(environment.BaseUrl + "Daro/Ticket/ReplyTicket",body,{headers}).pipe(
        map(data=>{
          return data as any
        })
      )

  }


  uploadFile(body,Token:String){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Ticket/Upload?token="+Token,body).pipe(
      map(data=>{

        return data
      })
    )
  }

}
